import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Users, Send, LogOut, Mail, RefreshCw, Settings as SettingsIcon, FileDown, UserCheck } from "lucide-react";

const navItems = [
  { to: "/campaigns", label: "Campaigns", icon: Send, testid: "nav-campaigns" },
  { to: "/recipients", label: "Recipients", icon: Users, testid: "nav-recipients" },
  { to: "/template", label: "Template", icon: Mail, testid: "nav-template" },
  { to: "/sync", label: "Sync events", icon: RefreshCw, testid: "nav-sync" },
  { to: "/reports", label: "Reports", icon: FileDown, testid: "nav-reports" },
  { to: "/staff-engagement", label: "Staff engagement", icon: UserCheck, testid: "nav-staff" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex" style={{ background: "var(--rahi-bg)" }}>
      {/* SIDEBAR */}
      <aside className="w-[240px] shrink-0 border-r flex flex-col" style={{ borderColor: "var(--rahi-border)", background: "var(--rahi-surface)" }}>
        <div
          className="px-6 pt-8 pb-10 cursor-pointer"
          onClick={() => navigate("/campaigns")}
          data-testid="brand-logo"
        >
          <div className="font-display text-2xl font-black tracking-tight leading-none">
            RAHI<span style={{ color: "var(--rahi-red)" }}>·</span>mailer
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] mt-2" style={{ color: "var(--rahi-soft)" }}>
            Rise Against Hunger India
          </div>
        </div>

        <nav className="flex flex-col px-3 gap-1 flex-1">
          {navItems.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm transition-all ${
                  isActive ? "bg-[#FFF1ED] text-[#C7361A] font-medium" : "text-[#57534E] hover:bg-[#f5f3f0]"
                }`
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t" style={{ borderColor: "var(--rahi-border)" }}>
          <div className="text-xs mb-2" style={{ color: "var(--rahi-soft)" }}>Signed in</div>
          <div className="text-sm font-medium mb-3 truncate">{user?.email}</div>
          <button onClick={logout} className="btn btn-ghost w-full justify-center" data-testid="logout-btn">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">{children}</main>
    </div>
  );
}
